import styled from 'styled-components';
import { Button } from '@bynder/design-system';

export const AddElementWrapper = styled.div`
    width: 40px;
`;

export const LayerButton = styled(Button)`
    max-width: 40px;
    max-height: 32px;
`;
